/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/3
 * @updateTime 2021/11/3
 * @decription 业务公共组件=》表单布局组件 入口js
 */
// 标题栏
import acTitleBar from '@/components/app/title-bar/index.vue';
export default {
    name: 'ac-layout-form',
    // 混入
    mixins: [],
    // 依赖组件
    components: {
        acTitleBar
    },
    // 参数
    props: {
        // 标题
        title: {
            type: String
        }
    },
    // 数据
    data() {
        return {
            // 私有变量
            scope: {
                // 类名前缀
                prefixCls: 'fd-ac-layout-form'
            }
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
        // 创建完成
    },
    // 组件激活
    activated() {
        // 激活完成
    },
    // 组件初始化完成
    mounted() {
        // 初始化完成
    },
    // 组件失去激活
    deactivated() {
        // 失去激活
    },
    // 销毁之前
    beforeDestroy() {
        // 销毁之前
    },
    // 方法
    methods: {
        /**
         * 标题栏组件-返回事件
         * */
        back() {
            this.$emit('back');
        },
        /**
         * 标题栏组件-返回首页事件
         * */
        goHome() {
            this.$emit('go-home');
        },
        /**
         * 置顶
         * */
        goToTop() {
            this.$refs.mainCon.scrollTop = 0;
        }
    }
};
